
import CatalogGridCard from "../../../common/catalog/CatalogGridCard";
import PublicationCoverImage from "../../../common/catalog/PublicationCoverImage";

export default function Publication({ publication }) {
	const authorName = (publication.profile_detail?.name ?? "").trim();

	return (
		<CatalogGridCard
			to={`/publication_detail/${publication.id}/`}
			title={publication.title}
			imageUrl={publication.image_url}
			subtitle={authorName || "نویسنده ثبت نشده"}
			instructorAvatarUrl={publication.profile_detail?.avatar_url}
			subtitleMuted={!authorName}
			showFreeBadge={false}
			actionLabel="مشاهده مقاله"
			imageSlot={
				<PublicationCoverImage
					src={publication.image_url}
					alt=""
					variant="card"
				/>
			}
		/>
	);
}
